import axiosIns from "@/api/axios";

export const GET_USERS_ATRIBUTE = () => {
    return axiosIns.get(`/user/attributes`);
};

export const ADD_DATA_USERS = (args) => {
    return axiosIns.post(`/user/iam`, args);
};